import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { grammarPointDetailSchema } from '../schemas';

const sysGrammarPointSchema = grammarPointDetailSchema.extend({
  approved: z.boolean(),
  createdAt: z.number().int(),
  updatedAt: z.number().int(),
});

const listSysGrammarPointsV1DataSchemaDefinition = z.object({
  points: z.array(sysGrammarPointSchema),
  nextCursor: z.string().nullable(),
});

export const listSysGrammarPointsV1DataSchema: typeof listSysGrammarPointsV1DataSchemaDefinition =
  listSysGrammarPointsV1DataSchemaDefinition;

export type IListSysGrammarPointsV1Data = z.infer<typeof listSysGrammarPointsV1DataSchema>;

export const listSysGrammarPointsV1ResponseSchema: z.ZodSchema<IAPI<IListSysGrammarPointsV1Data>> =
  createApiResponseSchema(listSysGrammarPointsV1DataSchema) as z.ZodSchema<
    IAPI<IListSysGrammarPointsV1Data>
  >;

export type IListSysGrammarPointsV1Response = IAPI<IListSysGrammarPointsV1Data>;
